<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.browsePathEdit}}</h3>
</div>
<div class="modal-body">
    <form>
    	<div class="paths-container" style="margin-bottom:16px;">
    		<!-- display -->
	    	<div class="row" *ngFor="let entry of browsedata | keyvalue" [hidden]='pageMetadataEdit'>
		    	<div class="col-sm-12" [hidden]="entry.value.deleted">
			        <div class="col-sm-10 tag label label-accent truncate-tag" style="text-align:left; margin:2px 0;" title="{{entry.key}}">
			            {{entry.key}}
			        </div>			      
			        <div class="col-sm-2 btn-group" style="display:inline-block; margin:2px 0;">
						<button (click)='initializeInlineEdit(entry.key)' 
							*ngIf='userPermissions["ROLE_PRODUCT_UPDATE"]' 
							type="button" 
							class="btn btn-xs btn-primary" 
							title="{{LOCALIZATION.edit}}">
								<i class="fa fa-edit"></i>
						</button>
						<button (click)='removePath(entry.key)' 
							*ngIf='userPermissions["ROLE_PRODUCT_UPDATE"]' 
							type="button" 
							class="btn btn-xs btn-danger" 
							title="{{LOCALIZATION.deleteItem}}">
								<i class="fa fa-trash"></i>
						</button>		        
			        </div>
		        </div>
	        </div>
	        <!-- edit existing path(s) -->
	        <div class="row" *ngIf='pageMetadataEdit'>
		        <div class="form-horizontal">
			        <div class="form-group" *ngFor="let step of copysteps; let i = index;">
			            <label for="s_{{step.name}}" class="col-sm-3 control-label">{{step.displayName}}</label>
			            <div class="col-sm-7">
					        <input 
					        	*ngIf="!step.suggest && step.type === 'string'" 
					        	type="text" 
					        	class="form-control" 
					        	[(ngModel)]="step.value" 
					        	id="s_{{step.name}}" 
					        	name="s_{{step.name}}"
					        />
					        
					        <!-- // Suggest implementation -->
							<!-- // Old
					        <input 
					        	*ngIf="step.suggest && step.type != 'list'" 
					        	uib-typeahead="term for term in getSuggestions(step.name, $viewValue)" 
					        	typeahead-min-length="2" 
					        	type="text" 
					        	class='form-control' 
					        	data-[(ngModel)]="step.value" 
					        	id="s_{{step.name}}">
					        -->
							<input 
							  *ngIf="step.suggest && step.type !== 'list'" 
							  [(ngModel)]="step.value"
							  [ngbTypeahead]="search"
							  type="text" 
							  class="form-control suggestion-container"
							  id="s_{{step.name}}"
							  name="s_{{step.name}}" 
							  [attr.data-fieldname]="step.name"
							  aria-label="Browse value input" 
							/>					        
					        
					        <!-- // Original -->
					        <!-- 
					        <select *ngIf="step.type == 'list'"
					        	 class="form-control"
					        	 id="s_{{step.name}}" name="s_{{step.name}}"
					        	 [(ngModel)]="step.value" 
								 ng-init='updateFn(step, i)' ng-change='updateFn(step, i)'
	                			 ng-options="option.value as option.name for option in step.options | filter: (step.filter ? step.filter : '') : (step.filter ? filtercomparator : false)">					        	 
					        </select>
					        -->
							<select *ngIf="step.type === 'list'"
							    class="form-control"
							    id="f_{{ step.name }}"
							    name="f_{{ step.name }}"
							    [(ngModel)]="step.value"
							    (change)="updateFn(step)">
							    <option *ngFor="let option of step.filteredOptions" [value]="option.value">
							        {{ option.name }}
							    </option>
							</select>															
			            </div>
			        </div>
			        <div class="centerMeta form-group primary-controls">
			        	<button (click)='initializeInlineEdit()' type="button" class="btn btn-default">{{LOCALIZATION.cancel}}</button>
						<button (click)='saveInlineEdit()' *ngIf='userPermissions["ROLE_PRODUCT_UPDATE"]' type="button" class="btn btn-primary">{{LOCALIZATION.save}}</button>
			        </div>
		        </div>	        
	        </div>
        </div>
        <!-- new entries -->
        <div class="form-horizontal well" *ngIf='!pageMetadataEdit'>
	        <div class="form-group" *ngFor="let field of data; let i = index;">
	            <label for="f_{{field.name}}" class="col-sm-3 control-label">{{field.displayName}}</label>
	            <div class="col-sm-7">
	                <input 
	                	*ngIf="!field.suggest && field.type == 'string'" 
	                	type="text" 
	                	class="form-control" 
	                	id="f_{{field.name}}" 
	                	name="f_{{field.name}}" 
	                	[(ngModel)]="field.value" 
	                />
					<input 
					  *ngIf="field.suggest && field.type != 'list'"
					  [(ngModel)]="field.value"
					  [ngbTypeahead]="search"
					  type="text" 
					  class="form-control suggestion-container"
					  id="f_{{field.name}}"
					  name="f_{{field.name}}" 
					  [attr.data-fieldname]="field.name"
					  aria-label="Browse value input" 
					/>	
	                
	                <!-- // Original -->
	                <!-- 
	                <select *ngIf="field.type == 'list'" 
	                	class="form-control"
	                	id="f_{{field.name}}" name="f_{{field.name}}" 
	                	[(ngModel)]="field.value" 
	                	ng-change='updateFn(field,$index)'
	                	ng-options="option.value as option.name for option in field.options | filter: (field.filter ? field.filter : '') : (field.filter ? filtercomparator : false)">
	                </select>
	                -->
					<select *ngIf="field.type === 'list'"
					    class="form-control"
					    id="f_{{ field.name }}"
					    name="f_{{ field.name }}"
					    [(ngModel)]="field.value"
					    (change)="updateFn(field)">
					    <option *ngFor="let option of field.filteredOptions" [value]="option.value">
					        {{ option.name }}
					    </option>
					</select>
					
	            </div>
	        </div>
	        <div class="centerMeta form-group">
	        	<button (click)="addPath()" class="btn btn-primary" type="button">{{LOCALIZATION.browsePathAdd}}</button>
	        </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="update()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.submit}}
    </button>
</div>
